import { Restart } from '@clearkit/icons';
import { CKButton, CKLayoutHorizontal, CKSwitch } from 'clearkit';

import { GridList } from '~/components/unified/GridList';
import { AccountFlagEnum } from '~/generated/graphql';
import useDeveloperOverride from '~/hooks/account/useDeveloperOverride';
import useFeatureFlag from '~/hooks/account/useFeatureFlag';

export default function FlagItem({ flag }: { flag: AccountFlagEnum }) {
  const override = useDeveloperOverride(`FEATURE_FLAG:${flag}`);
  const flagState = useFeatureFlag(flag);

  return (
    <GridList.Item className="items-center px-4 py-3">
      <div className="sticky left-0">
        <pre>{flag}</pre>
      </div>
      <CKLayoutHorizontal gap="2rem" justifyContent="end">
        {override.isOverridden ? (
          <CKButton
            leftIcon={<Restart />}
            onClick={() => {
              override.clearOverride();
            }}
            variant="tertiary"
          >
            Reset flag
          </CKButton>
        ) : null}
        <CKSwitch
          checked={flagState.enabled}
          onChange={(event) => {
            override.setOverrideValue(event.target.checked);
          }}
        >
          <CKSwitch.LabelEnabled>true</CKSwitch.LabelEnabled>
          <CKSwitch.LabelDisabled>false</CKSwitch.LabelDisabled>
        </CKSwitch>
      </CKLayoutHorizontal>
    </GridList.Item>
  );
}
